import { RsGeneratedAnswer } from "./web-components/rs-generated-answer/rs-generated-answer.js";
import { RsPager } from "./web-components/rs-pager/rs-pager.js";
import { RsRefineToggle } from "./web-components/rs-refine-toggle/rs-refine-toggle.js";
import { RsResultCard } from "./web-components/rs-result-card/rs-result-card.js";
import { RsSearchBox } from "./web-components/rs-search-box/rs-search-box.js";
import { RsSortDropdown } from "./web-components/rs-sort-dropdown/rs-sort-dropdown.js";
import { RsSortExpression } from "./web-components/rs-sort-expression/rs-sort-expression.js";

[
    ['rs-generated-answer', RsGeneratedAnswer],
    ['rs-pager', RsPager],
    ['rs-refine-toggle', RsRefineToggle],
    ['rs-result-card', RsResultCard],
    ['rs-search-box', RsSearchBox],
    ['rs-sort-dropdown', RsSortDropdown],
    ['rs-sort-expression', RsSortExpression]
].forEach(([name, className]) => window.customElements.define(name, className));